import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EnvironmentInjector,
  inject,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { RememberPasswordComponent } from './components/remember-password/remember-password.component';
import { FORGOT_PASSWORD_VISIBILITY } from './core/token/forgot-password-modal-visibility.token';
import { loadComponent } from './core/utils/load-component';
import { LoginService } from './services/login/login.service';
import { BEARER_TOKEN } from './core/constants/auth.constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    RememberPasswordComponent,
    NgOptimizedImage,
  ],
})
export class AppComponent implements AfterViewInit {
  title = 'leafio-authorization';

  isHealthcheck = window.location.pathname === '/up';

  forgotPassVisibility = inject(FORGOT_PASSWORD_VISIBILITY);

  @ViewChild('formContainer', { read: ViewContainerRef, static: false })
  formContainer: ViewContainerRef | undefined;

  private environmentInjector = inject(EnvironmentInjector);
  private cdr = inject(ChangeDetectorRef);

  ngAfterViewInit(): void {
    if (this.isHealthcheck) return;

    loadComponent(this.environmentInjector, this.formContainer);
    this.cdr.detectChanges();
  }
}
